export const lineGraphClassName = 'line-graph';
